import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { UserPickerComponent } from './user-picker.component';
import { AvatarModule } from '@intranet/components/avatar';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
    declarations: [UserPickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        AvatarModule,
        OverlayModule
    ],
    exports: [UserPickerComponent]
})
export class UserPickerModule {}
